import styled from "styled-components";

export const ButtonContainer = styled.button`
  display: flex;
  padding: 8px 10px;
  background-color: transparent;
  align-items: center;
  gap: 10.126px;
  cursor: pointer;
  transition: 0.3s;
  border-radius: 4px;
  border: 1px solid var(--color-primary);
  color: var(--color-primary);
  font-size: 12px;
  font-weight: 600;
  line-height: normal;
  margin-top: 8px;
  

  &:hover {
    background-color: var(--color-primary);
    color: #fff;
  }
`;
